import { FC, Suspense } from 'react';
import { Routes, Route, Navigate } from 'react-router';

import { useRouter } from '@cvt/routing';
import ErrorBoundary from '@cvt/components/ErrorBoundary';
import { BodyLoading } from '@cvt/components/layout/BodyLoading';
import { useDocumentTitle } from '@shared/hooks/useDocumentTitle';

import { ProgramLayout } from '../components/ProgramLayout';
import { ViewEnrollments } from './ViewEnrollments';
import { ProgramEnroll } from './ProgramEnroll';
import { ProgramJourney } from './ProgramJourney';
import { ProgramLinkLanding } from './ProgramLinkLanding';


export const Programs: FC = () => {
  const router = useRouter();

  useDocumentTitle('Dirigo');

  return (
    <ProgramLayout>
      <ErrorBoundary>
        <Suspense fallback={<BodyLoading height="100%"/>}>
          <Routes>
            <Route path="/" element={<ViewEnrollments/>}/>
            <Route path="/enroll/:programId" element={<ProgramEnroll/>}/>
            <Route path="/journey/:enrollmentId" element={<ProgramJourney phase="welcome"/>}/>
            <Route path="/journey/:enrollmentId/step" element={<ProgramJourney phase="step"/>}/>
            <Route path="/journey/:enrollmentId/complete" element={<ProgramJourney phase="complete"/>}/>
            <Route path="/journey/:enrollmentId/today" element={<ProgramJourney phase="today"/>}/>
            <Route path="/journey/:enrollmentId/review" element={<ProgramJourney phase="review"/>}/>
            <Route path="/:slug" element={<ProgramLinkLanding/>}/>
            <Route path="*" element={<Navigate to={router.programs.path} replace/>}/>
          </Routes>
        </Suspense>
      </ErrorBoundary>
    </ProgramLayout>
  );
};
